// extracted by mini-css-extract-plugin
export default {"json__edit__wrapper":"json__edit__wrapper__mEdqt"};